import { render } from "./Download.vue?vue&type=template&id=23811e76&scoped=true&ts=true"
import script from "./Download.vue?vue&type=script&lang=ts"
export * from "./Download.vue?vue&type=script&lang=ts"

import "./Download.vue?vue&type=style&index=0&id=23811e76&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/mobile-mpe-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23811e76"]])

export default __exports__